<template>
    <Vue100vh class="modal d-flex flex-column align-center">
        <slot></slot>
    </Vue100vh>
</template>

<script>
	export default {
		name: 'Modal',
	};
</script>

<style scoped>
    .modal {
        width: 100%;
        position: absolute;
        background-color: #D9D9D9AA;
        top: 0;
        left: 0;
        z-index: 999;
        overflow: auto;
    }
</style>
